module.exports = __webpack_public_path__ + "img/e-substation.f1a2661f.png";